var render = function render(){var _vm=this,_c=_vm._self._c;return _c('keep-alive',[(_vm.$route.name === 'login'
    || _vm.$route.name === 'logout'
    || _vm.$route.name === 'password.forgot'
  )?_c('div',[_c('router-view'),_c('NotificationWrapper')],1):_c('div',[(_vm.mounted)?_c('ModuleLayout',{attrs:{"fullscreen":_vm.fullscreen}},[_c('router-view',{on:{"showFullscreen":_vm.showFullscreen}}),_c('NotificationWrapper')],1):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }